angular.module('BBPublicBooking').controller('CustomBookingText', ($scope, $rootScope, CustomTextService, LoadingService) => {

    const loader = LoadingService.$loader($scope).notLoaded();

    return $rootScope.connection_started.then(() => {
            return CustomTextService.BookingText($scope.bb.company, $scope.bb.current_item).then((msgs) => {
                    $scope.messages = msgs;
                    return loader.setLoaded();
                }
                , err => loader.setLoadedAndShowError(err, 'Sorry, something went wrong'));
        }
        , err => loader.setLoadedAndShowError(err, 'Sorry, something went wrong'));
});







// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/public-booking/custom-booking-text/bb_custom_booking_text.controller.js